import { useFormik } from "formik";
import { useTranslation } from "react-i18next";
import type { SubcriptionFormValues } from "../../types/form.types";
import type { FormikHelpers } from "formik";
import * as Yup from "yup";

const initialValues = {
  hobbies: [],
  email: "",
  phone: "",
  department: "",
  city: "",
  address: "",
  acceptTermsAndConditions: false,
};

export const useSubcriptionForm = (
  onSubmit: (
    values: SubcriptionFormValues,
    formikHelpers: FormikHelpers<any>
  ) => void
) => {
  const { t } = useTranslation();
  const validationSchema = Yup.object({
    hobbies: Yup.array()
      .min(1, t("field.hobbies.min"))
      .required(t("field.required")),
    email: Yup.string()
      .required(t("field.required"))
      .matches(
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        t("field.email.invalid")
      )
      .max(100, t("field.email.max", { maxChars: 60 })),
    phone: Yup.string()
      .matches(/^\d{1,10}$/, {
        message: t("field.phone.invalid", { maxChars: 10 }),
      })
      .required(t("field.required")),
    department: Yup.string().required(t("field.required")),
    city: Yup.string().required(t("field.required")),
    address: Yup.string()
      .required(t("field.required"))
      .min(8, t("field.address.min", { minChars: 8 }))
      .max(60, t("field.address.max", { maxChars: 60 })),
    acceptTermsAndConditions: Yup.boolean()
      .oneOf([true], t("field.acceptTermsAndConditions.invalid"))
      .required(t("field.required")),
  });

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit,
  });

  return {
    formik,
    validationSchema,
  };
};
